import {Link} from "react-router-dom";
import { getObject } from "../../../../shared/api/endpoints";
import { useState, useEffect } from "react";
import { typeObject } from "../../../../pages/single";
import Skeleton from "../../../singel-card/components/skeleton";

export const getStatus = ({quarter, year}: {quarter : number; year: number}) : number => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const quarterEndMonth = quarter *3;

    if (year < currentYear) return 1;
    
    if (year === currentYear && quarterEndMonth < currentMonth) return 1;

    return 0;
}

const ComfortItem = ({title, price, metro, image, id}: any) => {
    const [dataSingle, setDataSingle] = useState<typeObject[]>([]);
    const [isLoading, setIsLoading] = useState(false)

    const getFieldValue = (source: string) => {
        return dataSingle?.find((item) => item.source === source)?.data?.value;
    };

    useEffect(() => {
        if (isLoading) return;
        setIsLoading(true);
        window.scrollTo(0, 0);
        const fetchData = async () => {
            try {
                const {object_fields} = await getObject({id})
                setDataSingle(object_fields)
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, [])

    const deadlineQuarter = Number(getFieldValue('source_temp__apartment_deadline')) || 0;
    const deadlineYear = Number(getFieldValue('source_temp__apartment_year')) || 0;

    return <div className="comfort-item">
        <Link to={`/apartment/${id}`} className="comfort-item-link">
            <div className="comfort-item-img"
                style={{backgroundImage: `url(${image})`}}></div>
        </Link>
        <div className="comfort-item-info">
            <Link to={`/apartment/${id}`}>
                <p className="comfort-item-info-title">{title}</p>
            </Link>
            <div className="comfort-item-info-content">
                <div className="comfort-item-info-content-text">
                     <p className="comfort-item-info-text">
                        <svg width="17" height="19" viewBox="0 0 17 19" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 6.34285L8.5 1L16 6.34285V18H1V6.34285Z" stroke="#141414"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {!isLoading ? 
                            (getStatus({quarter: deadlineQuarter, year: deadlineYear}) ? 
                            'Объект сдан' : 'Объект не сдан') 
                        :  <Skeleton  className="comfort-item__skeleton"/>}
                    </p>
                    <p className="comfort-item-info-text">Цена: от {price.toLocaleString('ru-RU')} руб</p>
                    {metro && <p className="comfort-item-info-text">От метро: {metro}</p>}
                </div>
            </div>
        </div>
        <Link to={`/apartment/${id}`} className="comfort-item-btn button" data-title="«Поколение»">Подробнее</Link>
    </div>
}

export default ComfortItem;